<template>
    <marquee-text
          v-if="loaded"
          :duration="this.duration"
          :repeat="10"
          :reverse="this.reverse"
        >
        <div class="team-marquee__marquee">
            <div class="team-marquee__marquee-person" v-for="teammember in teammembers" :key="teammember.ID">
                <picture class="image image--border-radius team-marquee__marquee-person-cover">
                    <img class="team-marquee__marquee-person-image" :src="teammember.image">
                </picture>
                <div class="team-marquee__marquee-person-text">{{ teammember.name }}
                </div>
                <div>{{  teammember.role }}</div>
            </div>
        </div>
            
    </marquee-text>
</template>

<script>
import MarqueeText from 'vue-marquee-text-component'

export default {
    name: 'TeamMarquee',
    data() {
        return {
            loaded: false,
            teammembers: [],
            reverse: false,
            duration: 15,
        };
    },
    props: ['items', 'direction', 'speed'],
    mounted: function() {
        this.teammembers = JSON.parse(this.items);
        if(this.direction == 'reverse') {
            this.reverse = true;
        }
        this.duration = parseInt(this.speed);
        this.loaded = true;
    },
    components: {
        MarqueeText
    } 
};
</script>